/**
 * Lets a full-screen flow hide the web cookie banner while it is mounted.
 * The banner lives outside the router, so it reads this tiny store instead of
 * the route. Onboarding v3 uses it so the banner never covers the bottom CTAs
 * (native never shows the banner at all).
 */
let suppressors = 0;
const listeners = new Set<() => void>();

function emit(): void {
  listeners.forEach((listener) => listener());
}

/** Hides the banner until the returned release function runs. */
export function suppressCookieBanner(): () => void {
  suppressors += 1;
  emit();
  let released = false;
  return () => {
    if (released) return;
    released = true;
    suppressors = Math.max(0, suppressors - 1);
    emit();
  };
}

export function isCookieBannerSuppressed(): boolean {
  return suppressors > 0;
}

export function subscribeCookieBannerSuppression(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
